import React, { useEffect, useState } from "react"
import { Row, Col, Container } from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom"

// import images
import { useTranslation } from "react-i18next"
import loginBg from "assets/images/login/login-bg.webp"
import SAR_logo from "assets/images/login/sar-logo-2.svg"
import alyamama_logo from "assets/images/login/alyamama_logo.svg"
import rightVector from "assets/images/login/login_right_vector.webp"
import { InputOtp } from "primereact/inputotp"
import { resendVerifyOtp, verifyAndLogin } from "store/actions/authAction"
import { showAlert } from "store/reducers/alertReducer"
import { convertArabicToNumber } from "components/Common/Utils"

const VerifyAndLogin = () => {
  const { t } = useTranslation()
  document.title = t("Verify And Login | Yamama")

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isLoading } = useSelector(state => state.Login)

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const user_uuid = searchParams.get("user_uuid")
  const sessionId = searchParams.get("sessionId")
  const phone_number = searchParams.get("phone_number")

  const [otp, setOtp] = useState("")
  const [timer, setTimer] = useState(30) // 5 minutes = 300 seconds
  const [isResendDisabled, setIsResendDisabled] = useState(true)

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(prev => prev - 1)
      }, 1000)
      return () => clearInterval(interval)
    } else {
      setIsResendDisabled(false)
    }
  }, [timer])

  const handleVerify = () => {
    const payload = {
      uuid: user_uuid,
      sessionId,
      otp: convertArabicToNumber(otp),
    }

    dispatch(verifyAndLogin(payload))
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          navigate("/profile")
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(err => {})
  }

  const handleResendOtp = () => {
    const payload = {
      sessionId,
    }
    dispatch(resendVerifyOtp(payload))
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          setIsResendDisabled(true)
          setTimer(300) // Reset timer to 5 minutes
          navigate(
            `/verify-and-login?user_uuid=${user_uuid}&sessionId=${data?.sessionId}&phone_number=${phone_number}`
          )
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(err => {})
  }

  const formatTime = seconds => {
    const min = Math.floor(seconds / 60)
    const sec = seconds % 60
    return `${min}:${sec < 10 ? `0${sec}` : sec}`
  }

  return (
    <React.Fragment>
      <div className="login_page h_100 overflow-x-hidden">
        <Container fluid className="h_100">
          <Row
            // style={{
            //   backgroundImage: "url('" + loginBg + "')",
            // }}
            className="bg_991"
          >
            <Col lg={6} className="px-0 r_no">
              <div className="left_section position-relative">
                <img src={loginBg} className="login_bg" alt="" />
                <div className="login_footer">
                  <Link to={"/login"}>
                    <img src={SAR_logo} alt="" width={110} height={61} />
                    <img src={alyamama_logo} alt="" width={110} height={61} />
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg={6} className="px-0">
              <div className="right_section g_center h-100 position-relative">
                <img src={rightVector} alt="" className="login_right_vector" />
                <div className="otp_verification_page">
                  <div className="otp_form">
                    <div className="otp_form_inner p-3 p-lg-0">
                      <div className="login_top">
                        <Link to={"/login"}>
                          <img src={SAR_logo} alt="" width={110} height={61} />
                          <img
                            src={alyamama_logo}
                            alt=""
                            width={110}
                            height={61}
                          />
                        </Link>
                      </div>
                      <h2>{t("Please enter the sent code.")}</h2>
                      <div className="otp_section">
                        <InputOtp
                          value={otp}
                          onChange={e => setOtp(e.value)}
                          length={6}
                          pt={{ root: { placeholder: "------" } }}
                          mask
                        />
                      </div>
                      <button
                        className="main_btn"
                        onClick={handleVerify}
                        disabled={otp.length !== 6 || isLoading}
                      >
                        {t("Verify")}
                      </button>
                      <p>
                        {isResendDisabled ? (
                          <>
                            {t("You can request a new code after")}{" "}
                            <span>
                              {" "}
                              {formatTime(timer)} {t("minutes")}{" "}
                            </span>
                            {t("please check your registered mobile number.")}.
                          </>
                        ) : (
                          <button
                            className="resend_btn tr_btn"
                            onClick={handleResendOtp}
                            disabled={isLoading}
                          >
                            {t("Resend OTP")}
                          </button>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default VerifyAndLogin
